import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
const links = [{
  label: 'Despre mine',
  href: 'https://comunitatearise.ro/despremine'
}, {
  label: 'Oferte R.I.S.E.',
  href: 'https://wa.me/40771296017'
}, {
  label: 'Resurse Gratuite',
  href: 'https://wa.me/40771296017'
}, {
  label: 'Testimoniale',
  href: 'https://wa.me/40771296017'
}, {
  label: 'Contact',
  href: 'https://wa.me/40771296017'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="bg-rise-white text-rise-black sticky top-0 z-50 border-b border-gray-200" data-id="element-180">
      <div className="max-w-rise-content mx-auto px-6 h-20 flex items-center justify-between" data-id="element-181">
        <div className="font-playfair text-[24px] font-semibold tracking-wider text-rise-black" data-id="element-182">
          R.I.S.E.
        </div>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8 font-dm-sans text-[15px] font-medium" data-id="element-183">
          {links.map(link => <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" className="hover:text-rise-gold transition-colors" data-id="element-184">
              {link.label}
            </a>)}
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-rise-black hover:text-rise-gold transition-colors" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-185">
          {isOpen ? <X size={28} data-id="element-186" /> : <Menu size={28} data-id="element-187" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-rise-white border-b border-gray-200 px-6 py-4 flex flex-col gap-4 font-dm-sans text-[16px] absolute w-full shadow-lg" data-id="element-188">
          {links.map(link => <a key={link.label} href={link.href} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="hover:text-rise-gold transition-colors py-2" data-id="element-189">
              {link.label}
            </a>)}
        </div>}
    </nav>;
}